/**
 * 馨康宝
 *
 * @author 张毅
 *
 */

import Vue from 'vue'
Vue.config.productionTip = false

import {
	Base64
} from 'js-base64'
Vue.prototype.$base64 = Base64

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import Axios from 'axios'
Vue.prototype.$axios = Axios

import VueRouter from 'vue-router'
Vue.use(VueRouter)

import Vant, {Toast} from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)

import Moment from 'moment'
Vue.prototype.$moment = Moment

import {
	Marked
} from 'marked'
Vue.prototype.$marked = Marked

import './libs/iconfont/iconfont.css'

import util from './util'
Vue.prototype.$util = util
import './theme.css'

import routes from './routes'
const router = new VueRouter({
	mode: 'history',
	routes: routes
})

Vue.prototype.$appId = 'wxca876145135ace10'
Vue.prototype.$appSecret = 'c303a8f85f4f5ca6a380a349eef8abce'

import App from './App.vue'

function isMobile(value) {
	return /^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(value);                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      return /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(value);
}

const errMsg = function(code) {
	if (code === 400) {
		return '请求错误(400)';
	} else if (code === 401) {
		return '票据丢失或已过期，请重新登录 (' + code + ')';
	} else if (code === 403) {
		return '请求被服务器拒绝 (' + code + ')';
	} else if (code === 404) {
		return '找不到请求的资源 (' + code + ')';
	} else if (code === 408) {
		return '请求超时 (' + code + ')';
	} else if (code === 500) {
		return '服务器错误 (' + code + ')';
	} else if (code === 501) {
		return '服务器不具备完成请求的功能 (' + code + ')';
	} else if (code === 502) {
		return '服务器网关错误 (' + code + ')';
	} else if (code === 503) {
		return '服务器不可用 (' + code + ')';
	} else if (code === 504) {
		return '服务器超时 (' + code + ')';
	} else if (code === 505) {
		return '服务器不支持的 HTTP 协议版本 (' + code + ')';
	} else {
		return '错误 (' + code + ')';
	}
}

router.beforeEach((to, from, next) => {
	let token = sessionStorage.getItem('Authorization-Token');
	let regex = new RegExp('^zhangy:+');
	if ('/' === to.path) {
		sessionStorage.setItem('origin', to.query.origin || '')
		sessionStorage.setItem('deviceType', to.query.deviceType || '')
		sessionStorage.setItem('area', to.query.area || '')
		sessionStorage.setItem('address', to.query.address || '')
		//顾问手机号
		sessionStorage.setItem('adviserPhone', to.query.adviserPhone || '')
		sessionStorage.setItem('currentUrl', window.location.href)
	}
	if(token){
		next();
		return;
	}
	let origin = sessionStorage.getItem('origin');
	let adviserPhone = sessionStorage.getItem('adviserPhone');
	if (origin && isMobile(adviserPhone)) {
		next('/login' === to.path ? true : '/login');
	} else {
		next('/error' === to.path ? true : '/error');
	}

})
import {
	Notify
} from 'vant'
Vue.prototype.$axios.interceptors.request.use(
	function(config) {
		if (sessionStorage.getItem('Authorization-Token')) {
			config.headers['Authorization-Token'] = sessionStorage.getItem('Authorization-Token');
			// if(config.url === '/api/signin/healthQue' || config.url === '/api/adviser/getH5AreaAndChannel'){
			// 	config.headers['Authorization-Token']
			// 		= 'zhangy:J4ILG5UazWklLJBHPFWjUTTv9jy/j6om0tQKLOYSQsqwZFzk81J7MY7G+8mNSs66sddW7nWucf52bJVA5sTbAQ==';
			// }
		}
		return config;
	},
	function(error) {
		if (error.response) {
			Notify(errMsg(error.response.status));
		} else {
			Notify(error.message);
		}
		return Promise.reject(error);
	}
)

Vue.prototype.$axios.interceptors.response.use(
	function(response) {
		return response;
	},
	function(error) {
		if (error.response) {
			Notify(errMsg(error.response.status));
			if (error.response.status === 401) {
				sessionStorage.removeItem('Authorization-Token');
				window.setTimeout(function() {
					window.location = '/login';
				}, 1000);
			}
		} else {
			Notify(error.message);
		}
		return Promise.reject(error);
	}
)

new Vue({
	el: '#app',
	router,
	render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js